// Spypoint cameras of the sections. The extractCameraPhotos Cloud Function copies the latest photos of each camera
// to cameras/{cameraId} every hour; a section shows them when the admin turned its "Caméra" tab on and picked one.

// Past this, the "Caméra" tab warns that the camera has not sent anything recently
export const STALE_PHOTO_DAYS = 3;

// Firestore Timestamp, { seconds } (Timestamp as plain data), Date or date string to a Date (null if invalid)
export function toDate(value) {
  if (!value) {
    return null;
  }
  let date;
  if (typeof value.toDate === "function") {
    date = value.toDate();
  } else if (typeof value.seconds === "number") {
    date = new Date(value.seconds * 1000);
  } else {
    date = new Date(value);
  }
  return isNaN(date) ? null : date;
}

export function sectionHasCamera(section) {
  return Boolean(section && section.camera_info && section.camera_id);
}

export function isStalePhoto(value, now = new Date()) {
  const date = toDate(value);
  return !date || now - date > STALE_PHOTO_DAYS * 24 * 60 * 60 * 1000;
}

// e.g. "3 nov. 2026, 16 h 00"
export function formatPhotoDate(value) {
  const date = toDate(value);
  return date ? date.toLocaleString("fr-CA", { dateStyle: "medium", timeStyle: "short" }) : "";
}

// e.g. "il y a 5 min", "il y a 3 h", "il y a 2 j"
export function formatPhotoAge(value, now = new Date()) {
  const date = toDate(value);
  if (!date) {
    return "";
  }
  const minutes = Math.max(0, Math.floor((now - date) / 60000));
  if (minutes < 60) {
    return `il y a ${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  return hours < 48 ? `il y a ${hours} h` : `il y a ${Math.floor(hours / 24)} j`;
}
